import { Avatar } from "components/LEGACY/styled-components/Avatar"
import { Logout, VEllipsis } from "components/LEGACY/styled-components/Icons"
import { getAuth, signOut } from "firebase/auth"
import { WithRef } from "hooks/firestore/FirestoreDocument"
import { useUser } from "hooks/firestore/simple/useUser"
import missingAvatar from "images/avatars/missing_avatar.svg"
import React, { RefObject, useState } from "react"
import Popup from "reactjs-popup"
import "reactjs-popup/dist/index.css"
import styled from "styled-components"
import User from "types/firestore/user"

const UserItem = styled.div<{ open?: boolean }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 3rem;
  padding: 1rem 0;
  transition: all ease 0.2s;
  width: 100%;
`

const UserAvatarContainer = styled.div`
  width: 20%;
`

const UserAvatar = Avatar

const UserNameContainer = styled.div`
  color: white;
  font-weight: 400;
  margin: 0 0 0 1rem;
  width: 70%;
`
const UserMenuContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 10%;
`

const UserMenuButton = styled(VEllipsis)`
  color: white;
`
const StyledIcon = styled.div`
  margin-right: 0.375rem;
  transition: all ease 0.2s;
`
const StyledPopup = styled(Popup)`
  cursor: pointer;
  &-content {
    width: 100%;
    border: none !important;
    padding: 0 !important;
  }
`
const MenuItemContent = styled.div`
  align-items: baseline;
  display: flex;
  width: 100%;
  transition: all ease 0.2s;
`

const LogoutItemTitle = styled.span<{ active: boolean }>`
  color: ${props => (props.active && props.theme.danger) || props.theme.dark};
  transition: all ease 0.2s;
`

const UserMenuMenuContainer = styled.div`
  padding: 0.5rem 1rem;
`

const StyledUserMenuItem = styled.div`
  cursor: pointer;
`

const SidebarUser = React.forwardRef(
  (
    { user, ...props }: { user: WithRef<User>; open: boolean },
    ref: ((instance: HTMLDivElement | null) => void) | RefObject<HTMLDivElement> | null | undefined
  ) => {
    return (
      <UserItem ref={ref} {...props}>
        <UserAvatarContainer>
          <UserAvatar src={user.photoURL || missingAvatar} size="2rem" />
        </UserAvatarContainer>
        <UserNameContainer>{user.userName}</UserNameContainer>
        <UserMenuContainer>
          <UserMenuButton size="16" />
        </UserMenuContainer>
      </UserItem>
    )
  }
)
SidebarUser.displayName = "SidebarUser"

const LogoutMenuItem = ({ logout }: { logout: () => void }) => {
  const [hover, setHover] = useState(false)
  return (
    <StyledUserMenuItem onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <MenuItemContent onClick={logout}>
        <StyledIcon>
          {React.createElement(Logout, {
            size: "1.125rem",
            danger: hover && true,
            className: "styled-nav-icon",
            lightgrey: !hover && true,
          })}
        </StyledIcon>
        <LogoutItemTitle active={hover}>Logout</LogoutItemTitle>
      </MenuItemContent>
    </StyledUserMenuItem>
  )
}

const SideBarUserContainer = () => {
  const user = useUser()
  return user ? (
    <>
      <StyledPopup
        trigger={open => <SidebarUser user={user} open={open} />}
        closeOnDocumentClick
        position="top right"
        arrow={false}
        nested
      >
        <UserMenuMenuContainer>
          <LogoutMenuItem
            logout={() => {
              signOut(getAuth())
            }}
          />
        </UserMenuMenuContainer>
      </StyledPopup>
    </>
  ) : null
}

export default SideBarUserContainer
